/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UtilizationChartGroupBy {
    TOTAL = 'TOTAL',
    ORGANIZATION = 'ORGANIZATION',
    LAUNDRY_GROUP = 'LAUNDRY_GROUP',
    LAUNDRY = 'LAUNDRY',
    MACHINE = 'MACHINE',
    MACHINE_CATEGORY = 'MACHINE_CATEGORY',
    PROGRAM = 'PROGRAM'
}


export function UtilizationChartGroupByFromJSON(json: any): UtilizationChartGroupBy {
    return UtilizationChartGroupByFromJSONTyped(json, false);
}

export function UtilizationChartGroupByFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtilizationChartGroupBy {
    return json as UtilizationChartGroupBy;
}

export function UtilizationChartGroupByToJSON(value?: UtilizationChartGroupBy | null): any {
    return value as any;
}

